import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
  data?: any[];
  categoryName?: string;
  totalRecords?: number;
}

const initialState: InitialState = {};

const getListTimeKeepingHRSlice = createSlice({
  name: "getListTimeKeepingHR",
  initialState,
  reducers: {
    getListTimeKeepingHRStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getListTimeKeepingHRSuccess: (
      state,
      action: PayloadAction<{
        data: any[];
        categoryName?: string;
        totalRecords: number;
      }>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = [...(state.data ?? []), ...action.payload.data];
      state.categoryName = action.payload.categoryName;
      state.totalRecords = action.payload.totalRecords;
    },
    getListTimeKeepingHRFailed: (
      state,
      action: PayloadAction<{ type: string }>
    ) => {
      state = {
        status: ReduxStateType.ERROR,
        data: [],
        totalRecords: 0,
      };
    },
    resetListTimeKeepingHR: (state) => initialState,
  },
});

export const {
  getListTimeKeepingHRStart,
  getListTimeKeepingHRSuccess,
  getListTimeKeepingHRFailed,
  resetListTimeKeepingHR,
} = getListTimeKeepingHRSlice.actions;

export default getListTimeKeepingHRSlice.reducer;
